'use strict';

module.exports = {
    SIGN: 'サインイン',
    SIGN_JOIN: 'サインインまたは無料で参加する!',
    EMAIL_EXISTS: 'このアカウントは既に存在しています。',
    INVALID_EMAIL: '有効なEメールアドレスを入力してください',
    INVALID_FIRST_NAME: '入力してください 有効な名前',
    INVALID_LAST_NAME: '入力してください 有効な名字',
    INVALID_PASSWORD: '入力してください 6 - 20 文字 (A-Z, a-z, 0-9のみ)',
    INVALID_REPASSWORD: 'パスワードが一致しません。',
    INVALID_VALID_CODE: '入力してください 有効なコード',
    UNAVIALABLE_SERVICE: '現在このサービスはご利用いただけませんので、しばらくしてから再度お試し下さい。',
    EMPTY_VALID_CODE: '図上の文字を入力してください。',
    NOT_MEMBER: '会員ではありませんか。',
    ALREADY_MEMBER: 'AliExpress/Alibabaの会員ですか。',
    EMAIL: 'Eメールアドレス',
    CONTACT_NAME: '連絡先:',
    FIRST_NAME: '名前',
    LAST_NAME: '名字',
    PASSWORD: 'パスワード',
    REPASSWORD: 'パスワードを再入力:',
    EMPTY_CODE: '表示されたコード入力してください',
    REFRESH: '更新する',
    CREATE_MY_ACCOUNT: 'マイアカウントを作成する',
    NAME: '名前',
    VERIFICATION: '立証コード:',
    AGREE_MENT: 'アカウントの作成により、',
    AE_MEMBER_SHIP: 'AliExpress.com 無料会員同意',
    AND: 'および',
    PRIVACY_POLICY: '個人情報保護方針に同意したことになります',
    SLIDE_SUBMIT: '右にスライドして確認',
    SLIDE_SUBMIT_TIPS: '成功',
    LOADING: 'ロード中…',
    SLIDE_SUBMIT_ERROR_TIPS: '右にスライドして確認',
    SHOP_NOW: '今すぐお買い物をする',
    SIGN_IN: 'サイン',
    REGISTER_SMS: 'SMSから登録',
    REGISTER_EMAIL: 'Eメールで登録',
    PHONE_NUMBER: '電話番号',
    VALID_NUMBER: '有効な電話番号を登録して下さい。',
    SEND_SMS_CODE: 'SMSコードを送る',
    SMS_POLICY: 'お客様が入力された電話番号に、SMSを通じて確認コードが送信されます。 国番号と電話番号が正しいことをご確認下さい。',
    SEND_TO: 'コードをお送りしました',
    VERIFICATION_RECEIVED: '受け取られた確認コードを入力、あるいは',
    EDIT_NUMBER: '番号を編集して下さい。',
    RESEND_CODE: 'コードの再送信',
    LAST_STEP: '最終ステップ',
    SET_SIGN_IN_PASSWORD: 'アカウントをより安全にするために、サインインのパスワードを設定して下さい。',
    INVALID_PHONE_PASSWORD: '6から20文字 (文字と数字のみ)',
    NOT_CORRECT_CODE: 'コードが正しくありません。もう一度お試し下さい。',
    SAVE_PASSWORD: 'パスワードの保存',
    NO_RECEIVED_CODE: 'もしまだコードを受け取っていない場合',
    VIA_EMAIL: 'Eメールから登録して下さい'
};